import styled from 'styled-components';

export const ResourcesSubmitMobileWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;

  padding: 12px 8px;

  border-radius: 8px;
  background: rgba(139, 157, 195, 0.4);
`;

export const ResourcesSubmitMobileTitle = styled.h6`
  font-weight: 500;
  font-size: 12px;
  line-height: normal;
  letter-spacing: 1.2px;
  text-transform: uppercase;

  color: var(--color-text);
`;

//MINIMAL
export const ResourcesSubmitMobileMinimalWrapper = styled.div`
  min-width: 62px;
  min-height: 62px;
  max-width: 62px;
  max-height: 62px;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 100%;
  background: #323f5d;
  box-shadow: 0px 4px 4px 0px rgba(50, 63, 93, 0.1);
`;
